import { useGetRefundQuery } from "../api/Refunds";

import type { ObjectWithId } from "utils/ObjectWithId";

export interface UseNewRefundProps extends ObjectWithId {}

export function useRefundDetails({ id }: UseNewRefundProps) {
  const { currentData, isLoading, isError } = useGetRefundQuery({ id });

  return {
    refund: currentData,
    isRefundLoading: isLoading,
    isRefundError: isError,
  };
}
